module.exports = __webpack_public_path__ + "images/gwt-promo-banner-mobile-bg.jpg";